export enum OrderCommentVisibility {
    Internal = 'internal',
    Customer = 'customer',
}